import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, Col, FormFeedback, FormGroup, Label, Row } from "reactstrap";
import { authHeader } from '../../helpers/auth-header';
import { getSupplierID, loginUser, sendForgottenPassword, showCustomError } from '../../helpers/general';
import { history } from '../../helpers/history';
import MenuContext from '../layout/MenuContext';

import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
require('datatables.net-bs4');

const Login = props => {
    let { saveSearchID = '', tenderGuid = '' } = props;
    const { setNavMenu } = useContext(MenuContext);
    const [value, setValue] = useState({});
    const { login } = useSelector(state => state);
    const [showPassword, setShowPassword] = useState(false);
    const togglePassword = () => setShowPassword(!showPassword);

    function handleChange(e) {
        e.persist();
        setValue(value => ({
            ...value,
            [e.target.name]: e.target.value
        }));
    }

    const handleEnterKey = (e) => {
        if (e.key === 'Enter') {
            handleLogin();
        }
    }

    const handleLogin = () => {
        if (value && value.password.length > 0 && value.password.length > 0) {
            let userDetails = { email: value.email, password: value.password };

            loginUser(userDetails, true)
                .then(response => {
                    if (response.error === "") {
                        fetch(`./Suppliers/BusinessClassificationsCount?supplierID=${getSupplierID()}`, {
                            method: 'GET',
                            headers: authHeader()
                        })
                            .then(response => response.json())
                            .then(businessCategoryData => {
                                if (businessCategoryData === 0) {
                                    sessionStorage.setItem('ShowBusinessClassificationWarning', true);
                                }

                                fetch(`./NavMenu/GetNavBar?supplierID=${getSupplierID()}`, {
                                    method: 'GET',
                                    headers: authHeader(false, true)
                                })
                                    .then(response => response.json())
                                    .then(nav => {
                                        setNavMenu(nav);

                                        if (saveSearchID && saveSearchID !== '') {
                                            history.push(`/tenders?searchid=${saveSearchID}`);
                                        } else if (tenderGuid && tenderGuid !== '') {
                                            history.push(`/tender-details?tid=${tenderGuid}`);
                                        } else {
                                            history.push('/dashboard');
                                        }
                                    });
                            })
                            .catch(err => { console.log(err); return false; })
                    }
                    else {
                        showCustomError(response.error, 'Cannot Log In', 'warning')
                    }
                })
        } else {
            showCustomError('You must provide an email address and password', 'Missing Credentials', 'error')
        }
    }

    const checkEnforcedPasswordReset = async email => {
        return await fetch(`./Login/CheckEnforcedPasswordReset`, {
            method: 'POST',
            headers: authHeader(false, true),
            body: JSON.stringify(email)
        });
    }

    const handleEmailBlur = e => {
        let email = e.target.value;

        if (email !== null && email !== '') {
            checkEnforcedPasswordReset(email)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.prompt) {
                        if (data.requestNewLink) {
                            sendForgottenPassword(email)
                                .then(response => {
                                    if (response) {
                                        const html = `<p>You are required to reset your Sell2 password.  An email has been sent to the email address <b>${email}</b>, with instructions on how to reset your Sell2 password.</p><p>Once this has been reset, you may access the Sell2 system.</p>`;
                                        showCustomError(html, 'Password Reset Required', 'warning', '50em');
                                    }
                                    else {
                                        const html = `<p>There has been a problem sending the password reset email - please make sure the email address is valid and also registered with the system.</p>`;
                                        showCustomError(html, 'Problem with the email address', 'Error')
                                    }
                                });
                        } else {
                            const html = `<p>The email address <b>${email}</b> has recently received an email with a Sell2 password reset link.</p><p>This link is still valid, or you <a href='/forgotten-password' style='text-decoration: underline;'>can click here to request a new password reset email</a></p>`;
                            showCustomError(html, 'Password Reset Required', 'warning', '50em');
                        }
                    }
                });
        }
    }

    return (
        <>
            <Card body className=" c-login-forms u-box-shadow u-component-spacing--2x">
                <div className="u-flex-center">
                    <h3 className="c-login-forms__heading u-component-spacing--2x c-broken-underline">
                        Log in to your account
                    </h3>
                </div>
                <div className="c-login-forms__form u-component-spacing">
                    <div className="c-login-forms__form u-component-spacing">
                        <div className="c-floating-label u-component-spacing">
                            <FormGroup>
                                <input
                                    name="email"
                                    type="email"
                                    className="c-floating-label__input form-control"
                                    onChange={(e) => handleChange(e)}
                                    onBlur={(e) => handleEmailBlur(e) }
                                    id="email"
                                    placeholder=" "
                                    data-error-message="Please enter a valid email address"
                                    required />
                                <Label className="c-floating-label__label" htmlFor="email">Email</Label>
                            </FormGroup>
                        </div>
                        <div className="c-floating-label u-component-spacing">
                            <FormGroup>
                                <input
                                    name="password"
                                    type={showPassword ? 'text' : 'password'}
                                    className="c-floating-label__input form-control"
                                    onChange={(e) => handleChange(e)}
                                    onKeyUp={(e) => handleEnterKey(e)}
                                    id="password"
                                    placeholder=" "
                                    required />
                                <Label className="c-floating-label__label" htmlFor="password">Password</Label>
                                <button className="c-floating-label__show-password" type="button" onClick={togglePassword}>{showPassword ? 'Hide' : 'Show'}</button>
                                <FormFeedback>
                                    <span id="password_LABEL"></span>
                                </FormFeedback>
                            </FormGroup>
                        </div>
                        <input type="submit" className="c-cta u-component-spacing" value="Login" onClick={handleLogin} />
                    </div>
                </div>

                <Link to="/forgotten-password" className="c-login-forms__forgot-password u-component-spacing--2x">I've forgotten my password</Link>

                <Row className="mt-2">
                    <Col xs={12} className="text-center">
                        <span>{login && login.error}</span>
                    </Col>
                </Row>
            </Card>
        </>
    )
}
export default Login;
